<template>
	<div class="sliders__block__child slider">
		<h4 v-html="title"></h4>

		<!-- Slider main container -->
		<div class="swiper-container">
			<!-- Additional required wrapper -->
			<div class="swiper-wrapper">
				<div
					class="swiper-slide"
					v-for="(slide, index) in JSON.parse(slides)"
					:key="index"
				>

					<h2 class="services" v-if="slide.title" v-html="slide.title"></h2>
					<h2 class="text" v-if="slide.text" v-html="slide.text"></h2>
					<a class="link" v-if="slide.link" :href="slide.link">Learn More</a>
				</div>
			</div>

			<div class="swiper-pag-nag">
				<div class="swiper-pagination"></div>

				<div class="swiper-nav">
					<div class="swiper-button-prev-testimonial">
						<img :src="prev_icon" alt="play" />
					</div>
					<div class="swiper-button-next-testimonial">
						<img :src="next_icon" alt="play" />
					</div>
				</div>
			</div>

			<!-- If we need scrollbar -->
			<!-- <div class="swiper-scrollbar"></div> -->
		</div>
	</div>
</template>

<script>
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Navigation, Pagination, Autoplay]);

export default {
	data() {
		return {
			smallSlider: null,
		};
	},

	props: {
		slides: {},
		title: {},
		play_icon: {},
		next_icon: {},
		prev_icon: {},
	},

	computed: {},

	watch: {},

	methods: {
		initSlider() {
			this.smallSlider = new Swiper('.swiper-container', {
				// Optional parameters
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				autoplay: false,
				observer: true,
				observeParents: true,

				// Navigation arrows
				navigation: {
					nextEl: '.swiper-button-next-testimonial',
					prevEl: '.swiper-button-prev-testimonial',
				},
			});
		},
	},

	components: {},

	created() {},
	mounted() {
		// eslint-disable-next-line no-unused-vars
		this.initSlider();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

/* write SCSS here */

.slider {
	background-color: white;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	padding: 50px;
	width: calc(100% - 100px);

	@media (max-width: 1500px) {
		padding: 50px;
		width: calc(100% - 100px);
	}
}

.swiper-container {
	width: 100%;
	// height: 250px;
	padding-bottom: 50px;

	.swiper-wrapper {
		.swiper-slide {
			width: 100% !important;

			.testimonial {
				color: $signs-teal;
				font-weight: bold;
				line-height: 1.75rem;
				margin-left: 1px;
			}

			.testifier {
				color: $signs-teal;
				font-weight: bold;
				margin-bottom: 0;
				margin-left: 1px;
			}

			.position {
				color: $signs-teal;
				font-weight: bold;
				margin-top: 0;
				margin-left: 1px;
			}

			.quote {
				font-family: 'Aveny-T PRO', Arial, Helvetica, sans-serif;
				color: #2e4a53;
				margin-bottom: 0;
				margin-left: 1px;
			}

			.services {
				color: $signs-teal;
				font-weight: bold;
				line-height: 1.75rem;
				word-break: break-all;
				margin-left: 1px;
			}

			.text {
				color: $signs-teal;
				font-weight: bold;
				line-height: 1.75rem;
				margin-left: 1px;
			}

			.link {
				color: $signs-pink;
				font-weight: bold;
				text-decoration: none;
				margin-left: 1px;
			}
		}
	}
}

.swiper-pagination {
	color: $signs-teal;
	width: 50%;
	left: 0;
	text-align: left;

	.fraction__dash {
		width: 50px;
		height: 1px;
		background: $signs-teal;
		display: inline-block;
		margin: 5px;
	}
}

.swiper-pag-nag {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	height: 40px;
	position: relative;
	width: 100%;
	bottom: 0;
	margin-top: 0;

	.swiper-nav {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		z-index: 10;
		position: absolute;
		width: 50%;
		right: 0;

		.swiper-button-prev-testimonial,
		.swiper-button-next-testimonial {
			display: flex;
			margin-left: 10px;

			&:hover {
				cursor: pointer;

				svg {
					path {
						&:first-of-type {
							fill: $signs-pink;
						}

						&:last-of-type {
							fill: white;
						}
					}
				}
			}

			img {
				height: 40px;
			}

			svg {
				height: 40px;

				path {
					transition: 0.2s fill ease;
				}
			}
		}
	}
}
</style>





// WEBPACK FOOTER //
// resources/assets/scripts/vue/SmallSlider.vue